import {useContext} from "react";
import AdvertContext from "../context/advertContext";

const useAdvert = () => {
  return useContext(AdvertContext);
};
export default useAdvert;
// ok
